<template>
  <div class="flex h-screen bg-gray-800">
    <SidebarPage @sidebar-toggled="handleSidebarToggle" />

    <div class="flex-1 flex flex-col transition-all duration-300 ease-in-out" :style="{ marginLeft: sidebarMargin }">
      <NavbarPage />
      <main class="flex-1 p-6 overflow-y-auto bg-slate-100 rounded-tl-xl">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import SidebarPage from '../Layout/SidebarPage.vue'; // Sesuaikan path
import NavbarPage from '../Layout/NavbarPage.vue'; // Sesuaikan path

export default {
  name: 'DashboardPage',
  components: {
    SidebarPage,
    NavbarPage,
  },
  data() {
    return {
      sidebarMargin: '16rem', // w-64
    };
  },
  methods: {
    handleSidebarToggle(isCollapsed) {
      this.sidebarMargin = isCollapsed ? '5rem' : '16rem'; // w-20 vs w-64
    },
  },
};
</script>